import axios from "infra/http";
import { useMutation } from "react-query";
import { UserEndereco } from "../typings/user";


export default function useSaveEndereco() {
  return useMutation(async (data: UserEndereco) => {
    const { data: result } = await axios.put("/v1/auth/current-endereco", {
      ...data,
    });

    return result;
  });
}
